import { Modal, Row, Col } from "antd";
import Toolbar from "components/Toolbar/index";
import { Flex, Box, Text } from "@chakra-ui/react";
import { CloseModalButton } from "components/Button/CloseModalButton";
import FooterModal from "components/Button/FooterModal";
import SelectUnidade from "ui/components/Input/SelectUnidade";
import SelectPessoas from "ui/components/Input/SelectPessoas";
import { TipoEntidadeEnum } from "resources/enums/conta";
import { useState, useEffect } from "react";
import SelectContaBancaria from "ui/components/Input/SelectContaBancaria";
import DateRangePicker from "components/Input/DateRangePicker/index";
import { ContaFiltroType, FiltroStatusEmail } from "features/conta/typings";
import SelectFormaPagamento from "components/Input/SelectFormaPagamento";
import SelectContaCategoria from "components/Input/SelectContaCategoria";
import FiltroTagStatus from "./components/FiltroTagStatus";
import { StatusBoletoEnum } from "resources/enums/conta";
import { OperacaoEnum } from "core/resources/enums/conta";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import FiltroEmailTag from "./components/FiltroEmailTag/index";
import SelectCentroDeCusto from "../../../../../Input/SelectCentroDeCusto/index";
import SelectTipoAnexoConta from "ui/components/Input/SeletctTipoAnexoConta";
import FiltroTipoLiquidacao from "./components/FiltroTipoLiquidacao/index";
import SelectGrupoUnidade from "ui/components/Input/SelectGrupoUnidade";

interface ModalFiltrosContaProps {
  open: boolean;
  onClose: () => any;
  update: (
    filed: Partial<ContaFiltroType> | keyof ContaFiltroType,
    value?: any
  ) => void;
  filtro: Partial<ContaFiltroType>;
  onReset: () => void;
  tenantId: string;
}

export default function ModalFiltrosConta({
  filtro,
  update,
  onClose,
  onReset,
  open,
  tenantId,
}: ModalFiltrosContaProps) {
  const { tenant } = useCurrentTenant();

  const [localFiltro, setLocalFiltro] =
    useState<Partial<ContaFiltroType>>(filtro);

  useEffect(() => {
    if (!open) {
      setLocalFiltro(filtro);
    }
  }, [open, filtro]);

  const isReceita = filtro.operacao === OperacaoEnum.Receita;

  const getTipoEntidadesFiltroPessoas = () => {
    if (tenant?.tipoTenantId === TipoTenantEnum.EmpresaComum && isReceita) {
      return [
        TipoEntidadeEnum.Condomino,
        TipoEntidadeEnum.Fornecedor,
        TipoEntidadeEnum.Cliente,
      ];
    } else if (isReceita) {
      return [TipoEntidadeEnum.Condomino, TipoEntidadeEnum.Fornecedor];
    }

    return [
      TipoEntidadeEnum.Fornecedor,
      TipoEntidadeEnum.Condomino,
      TipoEntidadeEnum.Cliente,
      TipoEntidadeEnum.Funcionario,
      TipoEntidadeEnum.Outros,
    ];
  };

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      destroyOnClose
      closable={false}
      className="antd-custom-header"
      width="900px"
      title={<Toolbar title="Filtrar" onClose={onClose} border="0px" />}
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              update(localFiltro);
              onClose();
            }}
            onClose={() => {
              onReset();
              //   setLocalFiltro(defaultContaValue);
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText="Filtrar"
            filtroValue={undefined}
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
            showBorderTop={false}
          />
        </Flex>
      }
    >
      <Box as={Row} gutter={16}>
        <Box as={Col} md={12} mb={4}>
          <Text mb="2px" fontSize="13px">
            Período
          </Text>
          <DateRangePicker
            allowEmptyDates={{
              dataInicio: true,
              dataFim: false,
            }}
            onChange={(dataInicio, dataFim) => {
              setLocalFiltro((state) => ({ ...state, dataInicio, dataFim }));
            }}
            value={{
              dataInicio: localFiltro.dataInicio!,
              dataFim: localFiltro.dataFim!,
            }}
          />
        </Box>

        <Box as={Col} md={12} mb={4}>
          <Text mb="2px" fontSize="13px">
            Pessoa
          </Text>
          <SelectPessoas
            tipoEntidades={getTipoEntidadesFiltroPessoas()}
            unidadeId={localFiltro.unidadeId}
            value={localFiltro.pessoaId}
            onChange={(pessoaId) => {
              setLocalFiltro((state) => ({ ...state, pessoaId }));
            }}
          />
        </Box>

        <>
          {TipoTenantEnum.Condominio === tenant.tipoTenantId && isReceita ? (
            <>
              <Box as={Col} md={12} mb={4}>
                <Text mb="2px" fontSize="13px">
                  Grupos de unidades
                </Text>
                <SelectGrupoUnidade
                  value={localFiltro.gruposUnidadesIds}
                  onChange={(gruposUnidadesIds) =>
                    setLocalFiltro((state) => ({ ...state, gruposUnidadesIds }))
                  }
                  mode="multiple"
                  placeholder="Todos os grupos de unidades"
                  allowClear
                />
              </Box>

              <Box as={Col} md={12} mb={4}>
                <Text mb="2px" fontSize="13px">
                  Unidades
                </Text>
                <SelectUnidade
                  tenantId={tenantId}
                  mode="multiple"
                  gruposUnidadesIds={localFiltro.gruposUnidadesIds}
                  onChange={(unidadesIds) => {
                    setLocalFiltro((state) => ({
                      ...state,
                      unidadesIds,
                      pessoaId: "",
                    }));
                  }}
                  value={localFiltro.unidadesIds}
                  allowClear
                />
              </Box>
            </>
          ) : null}


        </>
      </Box>

      <Box as={Col} md={24} mb={4}>
        <Text mb="2px" fontSize="13px">
          Categoria
        </Text>
        <SelectContaCategoria
          value={localFiltro.categoriasFinanceirasIds}
          multiple
          onChange={(categoriasFinanceirasIds) => {
            setLocalFiltro((state) => ({ ...state, categoriasFinanceirasIds }));
          }}
        />
      </Box>

      <Box as={Col} md={24} mb={4}>
        <Text mb="2px" fontSize="13px">
          Conta bancária
        </Text>
        <SelectContaBancaria
          value={localFiltro.contasBancariasIds}
          mode="multiple"
          onChange={(contasBancariasIds) => {
            setLocalFiltro((state) => ({ ...state, contasBancariasIds }));
          }}
        />
      </Box>

      <Box as={Col} md={24} mb={4}>
        <Text mb="2px" fontSize="13px">
          Centro de custo
        </Text>
        <SelectCentroDeCusto
          value={localFiltro.centrosDeCustoIds}
          mode="multiple"
          onChange={(centrosDeCustoIds) => {
            setLocalFiltro((state) => ({ ...state, centrosDeCustoIds }));
          }}
        />
      </Box>

      <Box as={Col} md={24} mb={4}>
        <Text mb="2px" fontSize="13px">
          Forma de pagamento
        </Text>
        <SelectFormaPagamento
          value={localFiltro.formasPagamentoIds}
          mode="multiple"
          onChange={(formasPagamentoIds) => {
            setLocalFiltro((state) => ({ ...state, formasPagamentoIds }));
          }}
        />
      </Box>

      <Box as={Row} mb={4} gutter={16}>
        <Box as={Col} md={12}>
          <Text mb="2px" fontSize="13px">
            Contém anexo do tipo
          </Text>
          <SelectTipoAnexoConta
            value={localFiltro.contemAnexoIds}
            mode="multiple"
            onChange={(ids) => {
              setLocalFiltro((state) => ({ ...state, contemAnexoIds: ids }));
            }}
          />
        </Box>

        <Box as={Col} md={12}>
          <Text mb="2px" fontSize="13px">
            Não contém anexo do tipo
          </Text>
          <SelectTipoAnexoConta
            value={localFiltro.naoContemAnexoIds}
            mode="multiple"
            onChange={(ids) => {
              setLocalFiltro((state) => ({ ...state, naoContemAnexoIds: ids }));
            }}
          />
        </Box>
      </Box>

      {filtro.operacao === OperacaoEnum.Receita ? (
        <Box as={Col} md={24} mb={2}>
          <Text mb="2px" fontSize="13px">
            Status da cobrança
          </Text>
          <FiltroTagStatus
            selectedTipoStatus={localFiltro.statusBoletoId}
            setSelectedTipoStatus={(statusBoletoId) =>
              setLocalFiltro((state) => ({
                ...state,
                statusBoletoId: statusBoletoId as StatusBoletoEnum,
              }))
            }
          />
        </Box>
      ) : null}
      {/* <Box as={Row} mb={2}>
        <Col sm={24}>
          <Text mb="5px">Status de e-mail</Text>
        </Col>

        <Col sm={24}>
          <FiltroTagEmail
            selectedTipoEmail={localFiltro.statusEmailId}
            setSelectedTipoEmail={(statusEmailId) =>
              setLocalFiltro((state) => ({
                ...state,
                statusEmailId: statusEmailId as FiltroStatusEmail,
              }))
            }
          />
        </Col>
      </Box> */}

      <Box as={Row} mb={2}>
        <Col sm={12}>
          <Text mb="5px">Status de e-mail</Text>
          <FiltroEmailTag
            selectedEmailStatus={localFiltro.emailEnviado}
            setSelectedEmailStatus={(emailEnviado) =>
              setLocalFiltro((state) => ({
                ...state,
                emailEnviado: emailEnviado as FiltroStatusEmail,
              }))
            }
          />
        </Col>

        <Col sm={12}>
          <Text mb="5px">Tipo de liquidação</Text>
          <FiltroTipoLiquidacao
            selectedEmailStatus={localFiltro.tipoLiquidacao}
            setSelectedEmailStatus={(tipoLiquidacao) =>
              setLocalFiltro((state) => ({
                ...state,
                tipoLiquidacao: tipoLiquidacao,
              }))
            }
          />
        </Col>
      </Box>
    </Modal>
  );
}
